import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      d: "M12 21c4.968 0 9-4.032 9-9s-4.032-9-9-9-9 4.032-9 9 4.032 9 9 9m0-1.5A7.494 7.494 0 0 1 4.5 12c0-4.147 3.353-7.5 7.5-7.5s7.5 3.353 7.5 7.5-3.353 7.5-7.5 7.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#464646",
      d: "M11.03 16.191c.29 0 .538-.141.714-.415l4.032-6.344c.097-.176.212-.37.212-.564 0-.398-.353-.653-.723-.653-.221 0-.442.14-.61.397l-3.661 5.876-1.738-2.25c-.212-.282-.406-.353-.653-.353-.38 0-.68.309-.68.697 0 .194.08.38.203.547l2.153 2.647c.22.292.459.415.75.415"
    }, null, -1)
  ])))
}
export default { render: render }